<template>
  <div v-if="params.data.__typename !== 'Folder'" class="ag-cell-color-renderer">
    <ColorPickerButton :color="params.value" data-test-id="color-picker-button" />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ICellRendererParams } from 'ag-grid-community';
import { GridableEntity } from '../utils/types';

export default defineComponent({
  props: {
    params: {
      type: Object as PropType<ICellRendererParams<GridableEntity, string>>,
      required: true,
    },
  },

  name: 'ColorRenderer',
});
</script>

<style lang="scss">
.ag-cell-color-renderer {
  padding: 12px 0;
  display: flex;
  cursor: text;
  align-items: center;
  height: 100%;
}
</style>
